import { IonIcon } from '@ionic/react';
import { football } from 'ionicons/icons';

export const GoalIcon: React.FC = () => (
  <IonIcon icon={football} style={{ color: 'blue' }} />
);
